import React from 'react'

// components
import { Avatar } from '@/components/commons/images/Avatar.component'
import { UserContext } from 'context'
import { ProfilePageContext } from 'context/profilePage/ProfilePageContext'
import { conditionalClass, cssClass } from '@/shared/utils'


// styles
import {
  avatarContainer,
  avatarContainerDesktop,
} from 'styles/v2/pages/profile'

import { ImageEditorModal } from '@/components/commons/imageEditor/EditorImageModal'
import { uploadUserAvatar } from '@/services/user'


export const ProfileAvatar: React.FC = () => {

  const { isAuthenticated, user, setUser } = React.useContext(UserContext)
  const { profile, ownProfile } = React.useContext(ProfilePageContext)
  const [showModal, setShowModal] = React.useState(false)

  const processImage = (url: string) => {
    setUser({ ...user, avatar: url })
  }

  const closeModal = () => {
    setShowModal(false)
  }

  return (
    <>
      {ownProfile && (
        <ImageEditorModal
          title='Preview Profile Image'
          showModal={isAuthenticated && ownProfile && showModal}
          closeModal={closeModal}
          originalImage={user?.avatar}
          onSaveImage={processImage}
          primaryButtonlabel='Update profile pic'
          serviceUpload={uploadUserAvatar}
          />
      )}
      <div className={cssClass(
        [
          avatarContainer,
          conditionalClass(ownProfile, 'cursor-pointer'),
        ])}>
        <Avatar
          onClick={() => setShowModal(true)}
          image={profile?.avatar}
          key="avatar_mobile"
          size={'100%'}
          username={profile?.username}
        />
      </div>

      <div className={cssClass(
        [
          avatarContainerDesktop,
          conditionalClass(ownProfile, 'cursor-pointer'),
        ])}>
        <Avatar
          onClick={() => setShowModal(true)}
          image={profile?.avatar}
          key="avatar_desktop"
          username={profile?.username}
        />
      </div>
    </>
  )
}
